import '../stylesheets/30th-anniversary.scss'
import thirtiethAnniversaryHero from './components/30th-anniversary-hero.svelte'
import thirtiethAnniversaryTimeline from './components/30th-anniversary-timeline.svelte'
import BigPicture from 'bigpicture'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

var $ = window.jQuery

gsap.registerPlugin(ScrollTrigger)

$(function () {
	var $body = $('body')

	if (!$body.is('.page-template-30th-anniversary')) {
		return
	}

	let $30thHero = $('#anniversaryHero')
	if ($30thHero.length) {
		new thirtiethAnniversaryHero({
			target: $30thHero[0],
			props: $30thHero.data(),
		})
	}

	let $30thTimeLine = $('#anniversaryTimeLine')
	if ($30thTimeLine.length) {
		new thirtiethAnniversaryTimeline({
			target: $30thTimeLine[0],
			props: $30thTimeLine.data(),
		})
	}

	let $anniversaryVideo = $('#anniversaryVideo')
	if ($anniversaryVideo.length) {
		$anniversaryVideo.on('click', function (e) {
			e.preventDefault()
			let $this = $(this)
			let ytSrc = $this.data('yt')
			let vidSrc = $this.data('video')

			if (vidSrc) {
				BigPicture({
					el: this,
					vidSrc,
					noLoader: true,
				})
			} else if (ytSrc == undefined) {
				let vimeoSrc = $this.data('vimeo')
				BigPicture({
					el: this,
					vimeoSrc,
					noLoader: true,
				})
			} else {
				BigPicture({
					el: this,
					ytSrc,
					noLoader: true,
				})
			}
		})

		let anni_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '#anniversaryVideo',
				delay: 0.75,
				start: 'top-=200 center',
			},
		})

		anni_tl.fromTo(
			'#anniversaryVideo',
			{
				opacity: 0,
				y: 20,
			},
			{
				duration: 0.5,
				delay: 0.1,
				opacity: 1,
				y: 0,
			}
		)
	}

	let $anniBuckets = document.querySelectorAll('.anniversary-buckets-item')
	if ($anniBuckets.length) {
		let anni_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.anniversary-buckets',
				delay: 0.75,
				start: 'top center',
			},
		})
		$anniBuckets.forEach((item) => {
			anni_tl.fromTo(
				item,
				{
					y: 20,
					opacity: 0,
				},
				{
					duration: 0.25,
					delay: 0,
					opacity: 1,
					y: 0,
				}
			)
		})
	}

	let $anniContent = document.querySelectorAll('.anniversary-wysiwig > *')
	if ($anniContent.length) {
		let anni_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.anniversary-wysiwig',
				delay: 0.75,
				start: 'top center',
			},
		})
		$anniContent.forEach((item) => {
			anni_tl.fromTo(
				item,
				{
					y: 20,
					opacity: 0,
				},
				{
					duration: 0.25,
					delay: 0,
					opacity: 1,
					y: 0,
				}
			)
		})
	}
})
